import Colors from 'components/Colors.js';
const colors = new Colors();

export const useColors = ({id}) => {
    return {
        backgroundColor: colors.getColorForHash(id)
    };
};
